import './page/acris-blog-author-create';
import './page/acris-blog-author-detail';
import './page/acris-blog-author-list';

const { Module } = Shopware;

Module.register('acris-blog-author', {
    type: 'plugin',
    name: 'AcrisBlog',
    title: 'acris-blog-author.general.mainMenuItemGeneral',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#a6c836',
    icon: 'regular-users',
    favicon: 'icon-module-settings.png',

    routes: {
        index: {
            component: 'acris-blog-author-list',
            path: 'index',
            meta: {
                parentPath: 'acris.blogs.index'
            }
        },
        detail: {
            component: 'acris-blog-author-detail',
            icon: 'regular-user',
            path: 'detail/:id',
            meta: {
                parentPath: 'acris.blog.author.index'
            }
        },
        create: {
            component: 'acris-blog-author-create',
            icon: 'regular-user',
            path: 'create',
            meta: {
                parentPath: 'acris.blog.author.index'
            }
        }
    }
});
